import { createBrowserRouter, Navigate } from 'react-router-dom';
import type { RouteObject } from 'react-router-dom';
import { RotaProtegida } from '../autenticacao/RotaProtegida.js';
import { Coletas } from '../pages/Coletas.js';
import { Configuracoes } from '../pages/Configuracoes.js';
import { ConflitoContagem } from '../pages/ConflitoContagem.js';
import { DetalheAbertura } from '../pages/DetalheAbertura.js';
import { DetalheInventario } from '../pages/DetalheInventario.js';
import { Dispositivos } from '../pages/Dispositivos.js';
import { DivergenciasDeSaldo } from '../pages/DivergenciasDeSaldo.js';
import { Depositos } from '../pages/Depositos.js';
import { EmBreve } from '../pages/EmBreve.js';
import { Entrar } from '../pages/Entrar.js';
import { Etiquetas } from '../pages/Etiquetas.js';
import { Inventarios } from '../pages/Inventarios.js';
import { Movimentacoes } from '../pages/Movimentacoes.js';
import { NaoEncontrada } from '../pages/NaoEncontrada.js';
import { Rastreabilidade } from '../pages/Rastreabilidade.js';
import { Sincronizacao } from '../pages/Sincronizacao.js';
import { Usuarios } from '../pages/Usuarios.js';
import { VisaoGeral } from '../pages/VisaoGeral.js';
import { Layout } from './Layout.js';

/** Telas de detalhe recolhem a barra lateral ao trilho de 64px. */
const NAV_COMPACTA = { navCompacta: true };

/**
 * Rotas do painel.
 *
 * Tudo abaixo de `RotaProtegida` exige sessão; `/entrar` é a única rota
 * pública. As seções ainda sem tela usam `EmBreve` porque a barra lateral do
 * sistema de design lista as nove desde o começo.
 */
export const rotas: RouteObject[] = [
  { path: '/entrar', element: <Entrar /> },
  {
    element: <RotaProtegida />,
    children: [
      {
        path: '/',
        element: <Layout />,
        children: [
          { index: true, element: <Navigate to="/visao-geral" replace /> },
          { path: 'visao-geral', element: <VisaoGeral /> },
          { path: 'coletas', element: <Coletas /> },
          { path: 'inventarios', element: <Inventarios /> },
          // O parâmetro é o id do CICLO, e não o depósito: `ALM01` teve N
          // contagens ao longo do tempo, e uma URL pelo depósito nunca saberia
          // de qual delas estava falando.
          { path: 'inventarios/:id', element: <DetalheInventario />, handle: NAV_COMPACTA },
          {
            path: 'inventarios/:id/conflito',
            element: <ConflitoContagem />,
            handle: NAV_COMPACTA,
          },
          { path: 'movimentacoes', element: <Movimentacoes /> },
          // A trilha de um produto é uma rota própria, e não uma aba: o
          // supervisor manda esse link para o encarregado do turno.
          { path: 'movimentacoes/produto', element: <Rastreabilidade /> },
          // O início e as entregas de uma movimentação em duas etapas (r1-mov).
          {
            path: 'movimentacoes/aberturas/:id',
            element: <DetalheAbertura />,
            handle: NAV_COMPACTA,
          },
          // Saldo do ERP diferente do daqui, esperando decisão (r1-sync).
          { path: 'saldos/divergencias', element: <DivergenciasDeSaldo /> },
          { path: 'dispositivos', element: <Dispositivos /> },
          { path: 'depositos', element: <Depositos /> },
          // O que o painel leu do ERP e o estado da leitura (r1-sync).
          { path: 'sincronizacao', element: <Sincronizacao /> },
          // Etiquetas de produto com o QR da plataforma (qr-code.md §14.3, §15).
          { path: 'etiquetas', element: <Etiquetas /> },
          { path: 'usuarios', element: <Usuarios /> },
          {
            path: 'relatorios',
            element: <EmBreve secao="Relatórios" titulo="Relatórios" tarefa="F3.5" />,
          },
          {
            path: 'auditoria',
            element: <EmBreve secao="Auditoria" titulo="Trilha de auditoria" tarefa="F3.5" />,
          },
          { path: 'configuracoes', element: <Configuracoes /> },
          { path: '*', element: <NaoEncontrada /> },
        ],
      },
    ],
  },
];

export const router = createBrowserRouter(rotas);
